<template>
  <el-container>
    <el-main class="topman">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data () {
    return {}
  },
  watch: {},
  created () {
  },
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>
